import React from 'react'
import ReactDOM from 'react-dom'
import './fontawesome.js'
import App from './app'

ReactDOM.render(<App />, document.getElementById('root'))
